if (!customElements.get('planted-product-card-bundle')) {
  function setClassesFromAttribute(attr, el) {
    const classes = (el.getAttribute(attr) || '').split(/\s+/)
    el.classList.add(...classes)
  }

  function unsetClassesFromAttribute(attr, el) {
    const classes = (el.getAttribute(attr) || '').split(/\s+/)
    el.classList.remove(...classes)
  }

  class PlantedProductCardBundle extends HTMLElement {
    connectedCallback() {
      const ctaEl = this.querySelector('[data-add-to-cart]')
      const bundleId = this.getAttribute('data-bundle-id')

      const self = this
      let variantId = this.getAttribute('data-product-variant-id')

      // variants only needed for bundles
      const variantPriceList = JSON.parse(
        self.querySelector('script[data-variant-prices]').innerText
      )
      const variants = {}
      variantPriceList.forEach((variant) => {
        variants[variant.variantId] = variant
      })

      function initBundleUI() {
        const bundle = window.bndlr
          .getBundles()
          .find((bundle) => String(bundle.id) === String(bundleId))
        if (bundle) {
          let price = 0
          let available = true
          const variantIds = Object.keys(bundle.products)
          variantIds.forEach(function (id) {
            const bundleVariant = bundle.products[id]
            const variant = variants[id]
            if (!variant || !variant.available) {
              available = false
            }
          })
          ctaEl.disabled = !available
          if (ctaEl.disabled) {
            const addToCardEl = this.querySelector('[data-add-to-cart-text]')
            addToCardEl.innerText =
              addToCardEl.getAttribute('data-sold-out-text')
          }

          ctaEl.addEventListener('click', function (event) {
            event.preventDefault()
            // add to cart
            const items = []
            let totalQuantity = 0
            variantIds.forEach(function (id) {
              const bundleVariant = bundle.products[id]
              totalQuantity += bundleVariant.quantity
              items.push({
                id: bundleVariant.id,
                quantity: bundleVariant.quantity,
                properties: {
                  [`_bundler_${bundle.id}`]: ''
                }
              })
            })

            let formData = {
              items
            }
            self.querySelector('[data-submit]').style.visibility = 'hidden'
            self.querySelector('[data-submitting]').style.visibility = 'visible'
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
              .then((response) => {
                self.querySelector('[data-submit]').style.visibility = 'visible'
                self.querySelector('[data-submitting]').style.visibility =
                  'hidden'

                return response.json()
              })
              .then((body) => {
                // notify the world
                fetch(window.Shopify.routes.root + 'cart.js')
                  .then((res) => res.json())
                  .then((cart) => {
                    const event = new CustomEvent('theme:added_to_cart', {
                      detail: {
                        cart,
                        changes: {
                          quantity: totalQuantity,
                          items: body.items
                        }
                      }
                    })
                    document.dispatchEvent(event)
                  })
              })
              .catch((error) => {
                console.error('Error:', error)
                self.querySelector('[data-submit]').style.visibility = 'visible'
                self.querySelector('[data-submitting]').style.visibility =
                  'hidden'
              })
          })
        }
      }
      if (window.bndlr) {
        initBundleUI()
      } else {
        document.addEventListener('bundler:loaded', initBundleUI.bind(this))
      }
    }
  }
  customElements.define('planted-product-card-bundle', PlantedProductCardBundle)
}
